<h2 class="align-center">Rapporter</h2>
<div class="flex-wrap flex-wrap--center margin--top-l">
  @for (rapport of rapporter; track rapport) {
    <div class="margin--left-l margin--right-l">
      <span class="tiny-text">d. {{ rapport.timeStamp | date: 'dd.MM.yyyy' }}</span>
      <button
        (click)="getDownloadLink(rapport.id)"
        class="btn-icon"
        type="button"
        [matTooltip]="'Download ' + rapport.shortName + '.' + rapport.fileType"
        [matTooltipClass]="'disableEllipsis'"
        >
        <span class="icon-with-text">
          @if ((rapport.fileType | lowercase) === 'pdf') {
            <mat-icon>picture_as_pdf</mat-icon>
          }
          @if (
            (rapport.fileType | lowercase) === 'jpg' ||
            (rapport.fileType | lowercase) === 'jpeg' ||
            (rapport.fileType | lowercase) === 'png'
            ) {
            <mat-icon
              >
              filter
            </mat-icon>
          }
          <span class="ellipsis">
            {{ rapport.shortName }}
          </span>
        </span>
      </button>
    </div>
  }
</div>
